var _style;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "master-artboard",
    viewBox: "0 0 800 800",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 1400 980"
    },
    width: "800px",
    height: "800px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "gradient-0",
    gradientUnits: "objectBoundingBox",
    cx: 0.49657338857650757,
    cy: 0.4982863962650299,
    r: 0.5,
    gradientTransform: "matrix(-0.692869925001709, -0.7019284843249007, 0.747051881248673, -0.7374095477217679, 0.468388365363962, 1.2142865613502736)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3e3ebd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#252570"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-1",
    gradientUnits: "userSpaceOnUse",
    x1: 654,
    y1: 778,
    x2: 654,
    y2: 884,
    gradientTransform: "matrix(0.006285939510698366, 0.9999803548749238, -0.9886442480149886, 0.00621499807182682, 1471.5431326323787, 172.57480623282822)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2e2e8c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#15153f"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gradient-2",
    gradientUnits: "objectBoundingBox",
    cx: 0.3809390664100647,
    cy: 0.4379660487174988,
    r: 0.5,
    gradientTransform: "matrix(2.448990534935366, -0.24477798373543752, 0.1813965192226603, 1.8148803489918937, -0.6124356169473313, -0.37624793516250943)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#21cd46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#137528"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gradient-3",
    gradientUnits: "objectBoundingBox",
    cx: 0.49143320322036743,
    cy: 0.5017135739326477,
    r: 0.5,
    gradientTransform: "matrix(1.6546356599474734, -0.5309274819018306, 0.46850702463269256, 1.4601002079524061, -0.5567660455354039, 0.03007685537205463)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2f4df5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0923b5"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gradient-4",
    gradientUnits: "objectBoundingBox",
    cx: 0.49657338857650757,
    cy: 0.4982863962650299,
    r: 0.5,
    gradientTransform: "matrix(-0.692869925001709, -0.7019284843249007, 0.747051881248673, -0.7374095477217679, 0.468388365363962, 1.2142865613502736)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3e3ebd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#252570"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-5",
    gradientUnits: "userSpaceOnUse",
    x1: 654,
    y1: 778,
    x2: 654,
    y2: 884,
    gradientTransform: "matrix(0.006285939510698366, 0.9999803548749238, -0.9886442480149886, 0.00621499807182682, 1471.5431326323787, 172.57480623282822)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2e2e8c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#15153f"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gradient-6",
    gradientUnits: "objectBoundingBox",
    cx: 0.3809390664100647,
    cy: 0.4379660487174988,
    r: 0.5,
    gradientTransform: "matrix(2.448990534935366, -0.24477798373543752, 0.1813965192226603, 1.8148803489918937, -0.6124356169473313, -0.37624793516250943)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#21cd46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#137528"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gradient-7",
    gradientUnits: "objectBoundingBox",
    cx: 0.49143320322036743,
    cy: 0.5017135739326477,
    r: 0.5,
    gradientTransform: "matrix(1.6546356599474734, -0.5309274819018306, 0.46850702463269256, 1.4601002079524061, -0.5567660455354039, 0.03007685537205463)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2f4df5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0923b5"
    }
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "ee-google-fonts"
  }, "@import url(https://fonts.googleapis.com/css?family=Bangers:400);")), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gradient-8",
    gradientUnits: "objectBoundingBox",
    cx: 0.23212097585201263,
    cy: 0.545088529586792,
    r: 0.5,
    gradientTransform: "matrix(2.0364367988030825, -0.5263917254836274, 0.4559289526499821, 1.763839557486516, -0.4891003656666492, -0.2941736407384875)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8c34e4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#59159d"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gradient-9",
    gradientUnits: "objectBoundingBox",
    cx: 0.2559918165206909,
    cy: 0.5291748642921448,
    r: 0.5,
    gradientTransform: "matrix(2.5493250608904567, -0.6027964443223368, 0.20619385677190638, 0.8720267356382472, -0.5057271456466231, 0.2220312052652262)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8c34e4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#59159d"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gradient-10",
    gradientUnits: "objectBoundingBox",
    cx: 0.46368715167045593,
    cy: 0.5065577626228333,
    r: 0.5,
    gradientTransform: "matrix(3.768204345765696, -1.147687120304795, 0.7482574390899592, 2.5821337029369698, -1.7582308924278276, -0.21722314230447548)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41e8d2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#15ae99"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gradient-11",
    gradientUnits: "objectBoundingBox",
    cx: 0.46940797567367554,
    cy: 0.5429278016090393,
    r: 0.5,
    gradientTransform: "matrix(2.6712061904117848, -0.6445347004238645, 0.3987150417215233, 1.6524335167486406, -0.9957916585887922, -0.041423953678667635)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2e0441"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gradient-12",
    gradientUnits: "objectBoundingBox",
    cx: 0.4891234338283539,
    cy: 0.7065274715423584,
    r: 0.5,
    gradientTransform: "matrix(1.05261376968107, 0.005161485269570137, -0.0026262954382599846, 0.9984202894466332, -0.04874275882672592, -0.21606585443946758)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a7fcc1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45f97b"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-13",
    gradientUnits: "objectBoundingBox",
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    gradientTransform: "matrix(0.9998419284820557, -0.018238509073853493, 0.017590343952178955, 1.0135252475738525, 0.00007903575897216797, 0.009119254536926746)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41e8d2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#15ae99"
    }
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "ee-background",
    x: 0,
    y: 0,
    width: 800,
    height: 800,
    style: {
      fill: "white",
      fillOpacity: 0,
      pointerEvents: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.349722385406494, 0, 0, 6.349722385406494, -3748.7023965564035, -4873.176448748178)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-1",
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M654,884c-29.2,0-53-23.8-53-53s23.8-53,53-53s53,23.8,53,53S683.2,884,654,884z M654,784 c-25.9,0-47,21.1-47,47s21.1,47,47,47s47-21.1,47-47S679.9,784,654,784z",
    style: {
      fill: "rgb(46, 4, 65)"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.867442466618668, 0, 0, 5.867442466618668, -3420.903957383871, -158.60598924656398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-5",
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M652,46c27.6,0,50,22.4,50,50s-22.4,50-50,50s-50-22.4-50-50S624.4,46,652,46z",
    style: {
      fill: "url('#gradient-9')",
      fillOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.08768367767334, 0, 0, 2.08768367767334, -1228.654177444159, -662.5823428259755)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M780.3,443.4c0,0-5.4,13-13.7,18c7.7-7.7,9.7-18.4,9.7-24.5c-19.8-19.8-53.3-4.7-67.3,0 c-14,4.7-29.9-7.9-29.9-7.9s-3.6,5.8,6.1,12.2c-10.1,2.9-20.5-4.3-20.5-4.3s-1.4,16.2,12.2,17.6c-17.3,11.5-38.5,54.3-18.7,96.8 c-5-14.4-2.3-47.3,12.2-61.9c-17.3,23.7-9,93.5,23,95.7c-13-7.6-20.9-32.4-17.3-51.1c0,16.6,9.7,58.3,50.9,58.3 c34,0,54.9-17.6,61.4-37.1c0,0-39.9,13.7-50.7-8.3c0,0,18.4,10.8,32-2.9c-14.8,0-27.7-17.3-19.8-37.1 c7.9-19.8,48.4-14.6,53.6-19.8c-6.5-6.5-27.7,0.7-39.6-1.4c11.7-11.7,43.9-9,50.4,5C830,463.9,809.5,438.7,780.3,443.4z M741.5,453.1c0,0,11.5-5.8,22.3-5.8C763.8,462.1,741.5,453.1,741.5,453.1z",
    style: {
      fill: "rgb(65, 232, 210)",
      opacity: 1
    },
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 552.11083984375 483.8988037109375 C 551.91748046875 483.8988037109375 551.2708129882812 484.0321350097656 550.1708374023438 484.2987976074219 C 549.07080078125 484.5588073730469 548.4108276367188 484.7287902832031 548.1908569335938 484.8088073730469 C 548.0175170898438 482.7154541015625 547.8741455078125 481.1888122558594 547.7608032226562 480.2287902832031 C 547.6408081054688 479.268798828125 547.5508422851562 478.54547119140625 547.4908447265625 478.0588073730469 C 547.4241333007812 477.3854675292969 547.3141479492188 476.5721435546875 547.1608276367188 475.6188049316406 C 547.1141357421875 475.9187927246094 547.0508422851562 476.2754821777344 546.9708251953125 476.6888122558594 C 546.8975219726562 477.1021423339844 546.82080078125 477.5521240234375 546.7408447265625 478.0387878417969 C 546.4874877929688 479.5387878417969 546.0974731445312 481.6954650878906 545.57080078125 484.5087890625 L 542.0508422851562 485.32879638671875 C 543.7841796875 476.6888122558594 544.8141479492188 470.8521423339844 545.1408081054688 467.81878662109375 C 545.6408081054688 467.78546142578125 546.11083984375 467.7488098144531 546.5508422851562 467.70880126953125 C 546.9908447265625 467.67547607421875 547.427490234375 467.6454772949219 547.86083984375 467.6188049316406 C 548.3008422851562 467.5921325683594 548.6841430664062 467.5654602050781 549.0108032226562 467.5387878417969 C 549.2174682617188 468.7721252441406 549.3807983398438 469.7921447753906 549.5008544921875 470.59881591796875 C 549.6275024414062 471.3988037109375 549.734130859375 472.0588073730469 549.82080078125 472.57879638671875 C 549.907470703125 473.0921325683594 549.9908447265625 473.5921325683594 550.07080078125 474.07879638671875 C 550.2241821289062 475.0321350097656 550.3875122070312 475.8754577636719 550.5608520507812 476.6087951660156 C 550.620849609375 476.2821350097656 550.6908569335938 475.8988037109375 550.7708129882812 475.45880126953125 C 550.850830078125 475.018798828125 550.9375 474.55548095703125 551.0308227539062 474.06878662109375 C 551.1241455078125 473.5754699707031 551.2241821289062 473.0754699707031 551.330810546875 472.56878662109375 C 551.4441528320312 472.05548095703125 551.580810546875 471.3988037109375 551.7408447265625 470.59881591796875 C 551.907470703125 469.7921447753906 552.1141357421875 468.77880859375 552.36083984375 467.5588073730469 L 555.2908325195312 467.20880126953125 C 553.57080078125 475.0087890625 552.5108032226562 480.5721435546875 552.11083984375 483.8988037109375 ZM 564.3854370117188 484.5087890625 C 563.6387939453125 484.4754638671875 562.85546875 484.45880126953125 562.0354614257812 484.45880126953125 C 561.2154541015625 484.45880126953125 560.3521118164062 484.4754638671875 559.4454345703125 484.5087890625 C 559.1321411132812 482.4888000488281 558.8187866210938 480.3088073730469 558.5054321289062 477.96881103515625 L 558.0554809570312 478.45880126953125 C 557.9487915039062 478.9454650878906 557.8287963867188 479.5387878417969 557.6954345703125 480.2388000488281 C 557.5621337890625 480.9454650878906 557.4254760742188 481.6521301269531 557.2854614257812 482.3587951660156 C 557.1454467773438 483.0721435546875 556.9954833984375 483.8354797363281 556.83544921875 484.6488037109375 L 552.9454345703125 485.2287902832031 C 554.6387939453125 477.41546630859375 555.6488037109375 471.5721435546875 555.9754638671875 467.69879150390625 C 556.3488159179688 467.7454833984375 556.7654418945312 467.7821350097656 557.2254638671875 467.8088073730469 C 557.6854858398438 467.82879638671875 558.1354370117188 467.85546875 558.575439453125 467.8887939453125 C 559.0154418945312 467.922119140625 559.4754638671875 467.9388122558594 559.9554443359375 467.9388122558594 C 559.942138671875 467.9988098144531 559.9188232421875 468.115478515625 559.8854370117188 468.2887878417969 C 559.8521118164062 468.4621276855469 559.8121337890625 468.672119140625 559.7654418945312 468.9187927246094 C 559.7188110351562 469.172119140625 559.6688232421875 469.44879150390625 559.615478515625 469.7488098144531 C 559.5621337890625 470.05548095703125 559.4854736328125 470.4621276855469 559.3854370117188 470.96881103515625 C 559.2854614257812 471.4754638671875 559.1554565429688 472.1687927246094 558.9954833984375 473.0487976074219 L 559.1354370117188 473.018798828125 C 559.575439453125 472.345458984375 560.02880859375 471.6354675292969 560.4954833984375 470.8887939453125 C 561.4354858398438 469.4021301269531 562.0921020507812 468.3788146972656 562.4654541015625 467.81878662109375 C 564.2654418945312 467.6788024902344 565.8587646484375 467.4988098144531 567.2454833984375 467.27880859375 C 564.5254516601562 470.9654541015625 562.6654663085938 473.615478515625 561.6654663085938 475.2287902832031 C 562.0121459960938 476.8354797363281 562.4287719726562 478.3921203613281 562.9154663085938 479.8988037109375 C 563.3954467773438 481.40545654296875 563.8854370117188 482.942138671875 564.3854370117188 484.5087890625 ZM 573.5079345703125 472.0387878417969 C 573.2412109375 470.8521423339844 572.7778930664062 470.2587890625 572.117919921875 470.2587890625 C 571.7112426757812 470.2587890625 571.271240234375 470.5421447753906 570.7979125976562 471.1087951660156 C 570.3179321289062 471.68212890625 569.867919921875 472.4121398925781 569.4479370117188 473.2987976074219 C 568.4945678710938 475.3788146972656 567.9879150390625 477.4187927246094 567.9279174804688 479.4187927246094 C 567.9279174804688 480.4187927246094 568.0745849609375 481.1288146972656 568.367919921875 481.5487976074219 C 568.6679077148438 481.9754638671875 569.01123046875 482.1888122558594 569.3978881835938 482.1888122558594 C 569.791259765625 482.1888122558594 570.1612548828125 482.10546875 570.5079345703125 481.9388122558594 C 570.847900390625 481.7721252441406 571.1512451171875 481.5487976074219 571.4179077148438 481.268798828125 C 572.0445556640625 480.615478515625 572.3712158203125 479.8421325683594 572.3978881835938 478.94879150390625 L 569.847900390625 479.32879638671875 L 570.2979125976562 476.95880126953125 C 572.4979248046875 476.6788024902344 574.4712524414062 476.38214111328125 576.2178955078125 476.06878662109375 C 576.1112670898438 477.6954650878906 575.791259765625 479.11212158203125 575.2579345703125 480.31878662109375 C 574.7312622070312 481.5321350097656 574.0946044921875 482.54547119140625 573.347900390625 483.3587951660156 C 572.60791015625 484.1721496582031 571.8079223632812 484.7821350097656 570.9479370117188 485.1888122558594 C 570.087890625 485.595458984375 569.3179321289062 485.7987976074219 568.6378784179688 485.7987976074219 C 567.9578857421875 485.7987976074219 567.3545532226562 485.6687927246094 566.827880859375 485.4088134765625 C 566.2945556640625 485.1488037109375 565.8312377929688 484.7554626464844 565.4379272460938 484.2287902832031 C 564.597900390625 483.1021423339844 564.1779174804688 481.518798828125 564.1779174804688 479.4787902832031 C 564.1779174804688 477.4388122558594 564.4745483398438 475.6521301269531 565.0679321289062 474.1188049316406 C 565.6612548828125 472.5921325683594 566.4078979492188 471.3154602050781 567.3079223632812 470.2887878417969 C 568.2012329101562 469.268798828125 569.1679077148438 468.5087890625 570.2078857421875 468.0087890625 C 571.2479248046875 467.5087890625 572.1512451171875 467.2587890625 572.9179077148438 467.2587890625 C 573.6845703125 467.2587890625 574.30126953125 467.37213134765625 574.7678833007812 467.59881591796875 C 575.2345581054688 467.8254699707031 575.617919921875 468.1254577636719 575.9179077148438 468.4988098144531 C 576.51123046875 469.21881103515625 576.8079223632812 470.1888122558594 576.8079223632812 471.4088134765625 L 573.5079345703125 472.0387878417969 Z",
    transform: "matrix(7.484282493591309, 0, 0, 7.484282493591309, -3664.74951171875, -3134.759521484375)",
    style: {
      fill: "url('#gradient-12')",
      whiteSpace: "pre",
      color: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("foreignObject", {
    className: "multi-line-input__container",
    x: 495.2247619628906,
    y: 436,
    height: 32,
    width: 224,
    transform: "matrix(1, 0, 0, 1, -4.668605099307797, 28.01163059584684)"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    className: "multi-line-input",
    style: {
      fontSize: 24,
      fontFamily: "'Open Sans', sans-serif",
      fill: "rgb(51, 51, 51)",
      whiteSpace: "pre",
      color: "rgb(51, 51, 51)",
      display: "inline-block"
    }
  })), /*#__PURE__*/React.createElement("foreignObject", {
    className: "multi-line-input__container",
    x: 644.6201171875,
    y: 477,
    height: 32,
    width: 224
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    className: "multi-line-input",
    style: {
      fontSize: 24,
      fontFamily: "'Open Sans', sans-serif",
      fill: "rgb(51, 51, 51)",
      whiteSpace: "pre",
      color: "rgb(51, 51, 51)",
      display: "inline-block"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d81e732161cadc00a73196742ba27aee.svg";
export { ForwardRef as ReactComponent };